export enum AuthorityTask {
  REGISTER_TASK_PRICE_VIEW = '1.15.13',
  REGISTER_TASK_PRICE_ADD = '1.15.12',
  REGISTER_TASK_PRICE_DELETE = '1.15.14',
  REGISTER_TASK_ADD_APPLICATION = '1.15.9',
  REGISTER_TASK_DELETE_APPLICATION = '1.15.8',
  REGISTER_TASK_VIEW_APPLICATION = '1.15.7',
  REGISTER_TASK_CHANGE_PRICES = '1.15.6',
  REGISTER_TASK_REPORTS = '1.15.5',
  REGISTER_TASK_EDIT = '1.15.4',
  REGISTER_TASK_DELETE = '1.15.3',
  REGISTER_TASK_ADD = '1.15.2',
  REGISTER_TASK_VIEW = '1.15.1',
  REGISTER_TASK_REGISTRATION = '1.15',
}
